import { CoreUsersByIdSalesforcePreferencesName } from './name';
import { createGetAsyncSlice } from '@sonar-software/xuder';
import { getUserSalesforcePreferences } from '@api';

export const coreUsersByIdSalesforcePreferencesGetAsyncSlice = createGetAsyncSlice({
	name: CoreUsersByIdSalesforcePreferencesName,
	receive: true,
	request: true,
	requestHandler: getUserSalesforcePreferences
});
